import BASE_RULE from '../baseRule';
import {FileSizeMetric, FileSizeType, SearchTypeFileSize} from './constants';
import {FileSizeRule} from './types';

export const fileSizeRuleDefaults: FileSizeRule = {
	...BASE_RULE,
	elementType: SearchTypeFileSize,
	elementSubType1: FileSizeType.APPROXIMATELY,
	elementSubType2: FileSizeMetric.BYTES,
	elementValue1: 0,
};

export default fileSizeRuleDefaults;
